export default "__VITE_ASSET__956f474e__"